import {
  Box,
  CircularProgress,
  keyframes,
  Stack,
  Typography,
} from '@mui/material';

import { CircularTickSvg } from '../../svgs/CircularTickSvg';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const progressSharedStyles = {
  variant: 'determinate',
  size: 32,
  thickness: 4,
} as {
  variant: 'determinate' | 'indeterminate';
  size: number;
  thickness: number;
};

export const StepItem = ({
  description,
  progress = 0,
  ticked,
  isCurrentStep,
}: {
  description: string;
  progress: number;
  ticked: boolean;
  isCurrentStep: boolean;
}) => {
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      {ticked ? (
        <Box
          sx={{
            animation: `${fadeIn} 0.2s ease-in`,
          }}
        >
          <CircularTickSvg />
        </Box>
      ) : (
        <Box
          sx={{
            position: 'relative',
          }}
        >
          <CircularProgress
            {...progressSharedStyles}
            value={100}
            sx={{ color: 'grey.300' }}
          />
          <CircularProgress
            {...progressSharedStyles}
            value={progress}
            sx={{ position: 'absolute', left: 0 }}
          />
        </Box>
      )}

      <Typography
        variant="h5"
        sx={{
          fontWeight: 'normal',
          ...(!ticked && !isCurrentStep && { color: 'text.secondary' }),
        }}
      >
        {description}
      </Typography>
    </Stack>
  );
};
